import React, { useEffect, useRef } from "react";
import { Form, Row, Col, Select, Radio, Alert, Input /*Checkbox*/ } from "antd";
import { required } from "../../../utils/rules";
import "./Steps.scss";

import { getByJunta, getEntidadesSeg, getFuncionarios, getPaisesVotoExtranjero, 
         getParametroPortal, getSedesVotoExtranjero, getState, obtenFechaJornada, 
         getEntities, getOrigenConvocatoriaCat, getCatalogoDiscapacidades } from "../../../api/requestPub";

import { adress } from "../../../utils/Request/functions";
import { radioButton, calle } from "../../../utils/rules";
import { FUNCIONARIO_CONSEJERO, IDCORTE, MSN_GUARDAR } from "../../../utils/constanst";
import { Ast } from "../../../utils/Public/functions";
import { useState } from "react";

export default function Additional(props) {
  //Se obtienen las funciones por props
  const tipoDiscapacidadOtro = 9;
  const {
    dataProcesoElectoral,
    handleChange,
    datos,
    setDatos,
    changeSelect,
    form,
    setJuntas,    
    juntas, 
    disabledObs, 
    observador, 
    ratifica, 
    detalle, 
    setFechaJornada, 
    setAnioFechaJornada, 
    modificar, 
    consultar, 
    setLoader,
    //setDatos,
    ambitoProceso, 
    setAmbitoProceso,
    showComboEstados,
    disabledRadio,
  } = props;

  const { Option } = Select;
  const isMounted = useRef(true);
  const [paisesVotoExtranjero, setPaisesVotoExtranjero] = useState([]);
  const [sedesVotoExtranjero, setSedesVotoExtranjero] = useState([]);
  const [entities, setEntities] = useState([]);
  const [entidadesCProceso, setEntidadesCProceso] = useState([]);

  //PEL2025. Constante donde se alamacena el catalogo de la convocatoria origen
  const [selectCatConvOrigen, setSelectCatConvOrigen] = useState([]);
  // PEL2025. Constante bandera que permite mostrar u ocultar el input donde se captura medio cuando se seleccionó la opción del "Otro".
  const [showTxtConvOrigen, setShowTxtConvOrigen] = useState(false);  

  const [selectDiscapacidades,      setSelectDiscapacidades] = useState([]);
  const [showOtraDiscapacidad,      setShowOtraDiscapacidad] = useState(false);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(()=>{

    if (!modificar && dataProcesoElectoral){
      setDatos({
        ...datos,
        idProceso     : dataProcesoElectoral.idProceso,
        idDetalle     : dataProcesoElectoral.idDetalle,
        nombreProceso : dataProcesoElectoral.nombreProceso,
      })

      /* PEJ2024-2025. Se establace por default a cero el votoExtranjero y voto en PP ya que 
         para este proceso no hay voto en el extranjero ni en PP.
         Por lo que el usuario pidio que se desabilite
      */
      setDatos({...datos, prisionPrev:0})
      form.setFieldsValue({
        votoExtranjero: 0,
        prisionPrev: 0
      });
      

      /**Se ejecuta el Onchange */

    } else {

      // cuando nos encontramos en la accion de modificar debemos setear los datos del proceso desde un inicio
      setDatos({
        ...datos,
        idProceso     : detalle[0].idProcesoElectoral,
        idDetalle     : detalle[0].idDetalleProceso  ,
        nombreProceso : detalle[0].nombreProceso     ,
      })
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  useEffect(() => {

    if (datos.tipoObservador === 0) {

      if (datos.entidadJunta) {
        //isMounted.current && getJuntas(datos.entidadJunta);
      } else {
        getEntidadesSeg().then((res) => {
          setJuntas((val) => ({ ...val, estados: res.data }));
          setEntidadesCProceso(res.data)
        }).catch((error) => {
          console.log("Ocurrio un error", error);
        });
      }
    } else {

      if(datos.entidadJunta) {
        //isMounted.current && getJuntas(datos.entidadJunta);
      } else {
        getEntidadesSeg().then((res) => {
          setJuntas((val) => ({ ...val, estados: res.data }));
          setEntidadesCProceso(res.data)
        }).catch((error) => {
          console.log("Ocurrio un error", error);
        });
      }
    }

    //PEL2025. Obtiene el catalo de convocatoria origen
    getOrigenConvocatoriaCat().then((res) => {
      console.log('En consulta getOrigenConvocatoriaCat res-->',res);
      setSelectCatConvOrigen(res.data);
    }).catch((error) => {
      console.log(error);
      setSelectCatConvOrigen([]);
    });

    //Se obtiene el catálogo de discapacidades
    getCatalogoDiscapacidades().then((res) => {
      setSelectDiscapacidades(res.data);
    }).catch((error) => {
      console.log(error);
      setSelectDiscapacidades([]);
    });

    //datos.capacitacion = 2; //Temporal en lo que se define el curso en línea
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [datos.entidadJunta]);

  useEffect(() => {

    if (datos.entidadJunta && datos.juntaEjecutiva) {
      //se obtiene el distrito de la junta ejecutiva seleccionada
      let distrito = datos.juntaEjecutiva.split("|");
      //se manda el idEstado y el idDistrito para obtener el nombre del funcionario
      isMounted.current &&
        getFuncionario(parseInt(datos.entidadJunta), parseInt(distrito[0]));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [datos.entidadJunta, datos.juntaEjecutiva]);

  useEffect(() => {

    //console.log('En el useEffect consulta observador-->',observador);

    //if (observador.idEstadoJunta !== undefined && observador.idEstadoJunta !== null) {
    if (observador.idEstadoJunta !== undefined && observador.idEstadoJunta !== null && !ratifica) {

      getState().then((res) => {

        for (let i = 0; i < res.data.length; i++) {
          if (res.data[i].id.idEstado === observador.idEstadoJunta) {
            form.setFieldsValue({
              //entidadJunta: res.data[i].nombreEstado
              entidadJunta: res.data[i].id.idEstado
            });
            datos.entidadJunta = observador.idEstadoJunta;
            //Se carga en el combo de Entidad de seguimiento la entidad junta de la BD, esto por si ya cerró el registro y no
            //aparezca el idEntidadJunta, se solventa de esta forma al ya no poder modificar el entidad/junta de seguimiento
            setJuntas((val) => ({ ...val, estados: res.data }));
            datos.conEntidad = res.data[i].nombreEstado;
          }
        }
      }).catch((error) => {
        console.log("Ocurrio un error", error);
      });

      //getByJuntaTablasLoc(observador.idEstadoJunta)

      getByJunta(observador.idEstadoJunta, observador.idCorte).then((res) => {

          for (let i = 0; i < res.data.domicilios.length; i++) {
            if (res.data.domicilios[i].idDistritoFederal === observador.idDistritoFederal) {
              //const juntaResponsable = `${res.data.domicilios[i].nombreSede} ${res.data.domicilios[i].idDistritoFederal} - ${res.data.domicilios[i].direccion}`;
              const juntaValue = `${res.data.domicilios[i].idDistritoFederal}|${res.data.domicilios[i].nombreSede}|${res.data.domicilios[i].direccion}`;
              form.setFieldsValue({
                //juntaEjecutiva: juntaResponsable
                juntaEjecutiva: juntaValue
              });
              datos.juntaEjecutiva = juntaValue
              getFuncionario(parseInt(observador.idEstadoJunta), parseInt(res.data.domicilios[i].idDistritoFederal));
            }
          }
          setJuntas((val) => ({ ...val, juntas: res.data.domicilios }));
      }).catch((e) => {
        console.log(e);
      });

      /* form.setFieldsValue({
        capacitacion: observador.modalidad
      });
      datos.capacitacion = observador.modalidad; */

      //Obtener la fecha de la jornada electoral para la entidad seleccionada
      for (let i = 0; i < detalle.length; i++) { //PARA PROCESOS LOCALES
        if(detalle[i].idEstado === observador.idEstadoJunta) {
          obtenFechaJornada(detalle[i].idProcesoElectoral, detalle[i].idDetalleProceso).then((res) => {
            setFechaJornada(res.data);
            let anioJornada=res.data.split("de")
            setAnioFechaJornada(anioJornada[2])
          })
          break;
        }
      }

      //Prisión preventiva y voto extranjero
      datos.prisionPrev = observador.prisionPreventiva;
      datos.votoAnticipado = observador.votoAnticipado;
      datos.votoExtranjero = observador.votoExtranjero;

      form.setFieldsValue({
        prisionPrev: observador.prisionPreventiva,
        votoExtranjero: observador.votoExtranjero,
        votoAnticipado:observador.votoAnticipado,
        comunidadIndigena: observador.comunidadIndigena,
        discapacidad: observador.tieneDiscapacidad,
        convocatoriaOrigenCatalogo:observador.catOrigenConvocatoria.idConvOrigen.toString(),
        convocatoriaOrigen: observador.convocatoriaOrigen ? observador.convocatoriaOrigen : "",
      });

      datos.comunidadIndigena = observador.comunidadIndigena
      datos.discapacidad = observador.tieneDiscapacidad

      // PEL2025
      datos.catOrigenConvocatoria = observador.catOrigenConvocatoria
      datos.convocatoriaOrigen = observador.convocatoriaOrigen;
            
      if( observador.convocatoriaOrigen !== null && observador.convocatoriaOrigen !== "" ) {
        setShowTxtConvOrigen(true)
        if ( observador.convocatoriaOrigen ) {
          form.setFieldsValue({
            convocatoriaOrigen:observador.convocatoriaOrigen
          });
        }
      } else {
        setShowTxtConvOrigen(false)
      }

      if( observador.tieneDiscapacidad === 1 ){

        datos.discapacidad = 1

        if(observador.discapacidad){

          setTimeout( function() { 
            form.setFieldsValue({
              tipoDiscapacidad: observador.discapacidad.idTipoDiscapacidad,
              txtDiscapacidad: observador.discapacidad.cualDiscapacidad
            });
          }, 1200);
          datos.tipoDiscapacidad = observador.discapacidad.idTipoDiscapacidad
          datos.txtDiscapacidad = observador.discapacidad.cualDiscapacidad
        }
        //Si el tipo discapacidad es Otro(s), se muestra el input ¿Cual?
        if(observador.discapacidad.idTipoDiscapacidad === tipoDiscapacidadOtro){
          setShowOtraDiscapacidad(true);
        }
      }

      //Pais y sede de voto extranjero de la solicitud
      if(observador.votoExtranjero === 1) {

        getPaisesVotoExtranjero().then((resAux) => {
          setPaisesVotoExtranjero(resAux.data.paisesVotoExtranjero);
          form.setFieldsValue({
            paisVotoExtranjero: observador.paisSedeVE.idPais
          });
          datos.paisVotoExtranjero = observador.paisSedeVE.idPais;
        }).catch((error) => {
          console.log(error);
          setPaisesVotoExtranjero([]);
        });
        getSedesVotoExtranjero(observador.paisSedeVE.idPais).then((resAux) => {
          setSedesVotoExtranjero(resAux.data.sedesVotoExtranjero);
          form.setFieldsValue({
            sedeVotoExtranjero: observador.paisSedeVE.idSede
          });
          datos.sedeVotoExtranjero = observador.paisSedeVE.idSede;
        }).catch((error) => {
          console.log(error);
          setSedesVotoExtranjero([]);
        });

      }
    }

    if(observador.modalidad !== undefined && observador.modalidad !== null) {
      form.setFieldsValue({
        capacitacion: observador.modalidad
      });
      datos.capacitacion = observador.modalidad;
    }

    if(observador.idProcesoElectoral && observador.idDetalleProceso){

        getEntities(observador.idProcesoElectoral, observador.idDetalleProceso).then((res) => {

          setEntities(res.data);

          // PEL2025: Se establece el valor de las entidades de seguimeinto
          //setEntSeguimiento(res.data)

          /*var entidadSeleccionada = [];
          for (let i = 0; i < observador.entidadesObservar.length; i++) {
            if (observador.entidadesObservar[i].checked) {
              entidadSeleccionada.push(''+observador.entidadesObservar[i].value+'');
            }
          }
          form.setFieldsValue({
            entidades: entidadSeleccionada,
          });
          datos.entidades = entidadSeleccionada;*/

        }).catch((e) => {
          console.log("Error al obtener las entidades: "+e);
        });

        obtenFechaJornada(observador.idProcesoElectoral , observador.idDetalleProceso).then((res) => {

          setFechaJornada(res.data);
          let anioJornada=res.data.split("de")
          setAnioFechaJornada(anioJornada[2])

        }).catch((e) => {
          console.log("Error al obtener la fecha jornada: "+e);
        });        
      }      

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disabledObs, observador]);

  useEffect(() => {

    //if (disabledObs && observador !== undefined && observador !== null && observador.entidadesObservar !== undefined 
    if (observador !== undefined && observador !== null && observador.entidadesObservar !== undefined 
      && observador.entidadesObservar !== null && entities.length > 0) {

        var entidadSeleccionada = [];
        for (let i = 0; i < observador.entidadesObservar.length; i++) {
          if (observador.entidadesObservar[i].checked) {
            entidadSeleccionada.push(''+observador.entidadesObservar[i].value+'');
          }
        }
        datos.entidades = entidadSeleccionada;
        setTimeout( function() { 
          form.setFieldsValue({
            entidades: entidadSeleccionada,
          });
        }, 1200);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entities, observador, ambitoProceso]);

  useEffect(() => {
      if(datos.idProceso && datos.idDetalle){

        getEntities(datos.idProceso, datos.idDetalle).then((res) => {

          setEntities(res.data);

          // PEL2025: Se establece el valor de las entidades de seguimiento
          //setEntSeguimiento(res.data)

        }).catch((e) => {
          console.log("Error al obtener las entidades");
        });
      }

      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [datos.entObservar]);

  /**
   *
   * @param {*} idEntidad
   * Función que obtiene las juntas ejecutivas a partir del estado seleccionado
   */
  const getJuntas = (idEntidad, idCorte) => {

    idEntidad && idCorte &&
      //getByJuntaTablasLoc(idEntidad)
      getByJunta(idEntidad, idCorte).then((res) => {

          setJuntas((val) => ({ ...val, juntas: res.data.domicilios }));
          setLoader({ loading: false, message: "" });

      }).catch((e) => {
        console.log(e);
        setLoader({ loading: false, message: "" });
      });
  };

  /**
   * Función tipo constante que revisa el evento de change del combo del 
   * catalogo del origen de la convocatoria para mostrar u ocultar el componente
   * de texto donde se captura cuando se selecciona la opción de "Otro".
   * 
   * @param {*} value 
   * @param {*} e 
   */
  const onChangeConvOrigen = (value, e) => {

    if ( e.children === 'Otro' ) {

      // Se muestra componente donde se captura el texto cuando la opción es "otro".
      setShowTxtConvOrigen(true);
      form.setFieldsValue({
        convocatoriaOrigen: null,
      });

    } else {

      // Se oculta componente donde se captura el texto cuando la opción es diferente de "otro"
      setShowTxtConvOrigen(false);
    }
  };


  //////////////////////////////OBTIENE EL PRESIDENTE/CONSERO Y LA DIRECCIÓN DEL MISMO /////////////////////////////////
  /**
   *
   * @param {*} idEntidad
   * @param {*} idDistrito
   * Función que obtiene el nombre del funcionario del estado y junta seleccionada
   */
  const getFuncionario = (idEntidad, idDistrito) => {

    getFuncionarios(observador.idProcesoElectoral, observador.idDetalleProceso, idEntidad, idDistrito).then((res) => {

        //Se filtra la respuesta para obtener el nombre del funcionario con el idPuesto 1
        const fun = getByFuncionario(
          FUNCIONARIO_CONSEJERO,
          res.data.integrantes
        );

        //Se valida que el funcionario exista
        if (fun) {

          //Destructuring del nombre del funcionario
          const {
            primerApellidoIntegrante,
            segundoApellidoIntegrante,
            nombreIntegrante,
          } = fun;

          //Se concate el nombre del funcionari y se almacena en el hook de datos
          datos.consejero = `${nombreIntegrante} ${primerApellidoIntegrante} ${segundoApellidoIntegrante}`;
          //Se obtiene la dirección del funcionario

        } else {

          //Se limpia el nombre del consejero en caso de que se haya almacenado información anteriormente
          datos.consejero = "";
        }

        const dir = getAdressFun(idEntidad, idDistrito);

        //Valida si es una junta local o distrital
        datos.conDistrito = idDistrito === 0 ? "Local" : "Distrital";
        //se valida que tenga información
        if (dir) {
          //Se almacenan los datos en el hook
          datos.conNumero = dir.idDistritoFederal;
          datos.conMunicipio = dir.nombreMunicipio;
          //datos.conEntidad = dir.nombreEstado; Se habilitará con el servicio de sesiones
        }

    }).catch((e) => {
      console.log(e);
      datos.consejero = "";
    });
  };

  //Función que obtiene el id y el nombre del estado de la junta seleccionada
  const getStateAdditional = (value, event) => {

    datos.entidadJunta = value; // El id del combo de la entidad junta
    datos.conEntidad = event.props.children; //Nombre del estado seleccionado

    //getJuntas(value); //Se carga nuevamente el combo con los datos correspondientes

    //Se limpia el combo de junta ejecutiva
    form.setFieldsValue({ juntaEjecutiva: undefined });
    datos.juntaEjecutiva = undefined;

    let ambitoNew;

    for(let z=0; z<entidadesCProceso.length;z++){
      if(Number(entidadesCProceso[z].id.idEstado)===Number(value)){
        setAmbitoProceso(entidadesCProceso[z].ambito)
        ambitoNew=entidadesCProceso[z].ambito
        break;
      }
    }

    if(ambitoNew==="L"){
      //Para PEL2022 que desaparece la sección de etidades a observar 
      var entidadSeleccionada = [];
      entidadSeleccionada.push(value);
      datos.entidades = entidadSeleccionada;
    }

    //Obtener la fecha de la jornada electoral para la entidad seleccionada
    for (let i = 0; i < detalle.length; i++) { //PARA PROCESOS LOCALES
      if(detalle[i].idEstado === value || ambitoNew==="F") {

        obtenFechaJornada(detalle[i].idProcesoElectoral, detalle[i].idDetalleProceso).then((res) => {
          setFechaJornada(res.data);
          let anioJornada=res.data.split("de")
          setAnioFechaJornada(anioJornada[2])
        }).catch((error) => {
          console.log(error);
        });

        setLoader({ loading: true, message: MSN_GUARDAR });

        getParametroPortal(detalle[i].idProcesoElectoral, detalle[i].idDetalleProceso, IDCORTE).then((res) => {
          getJuntas(value, parseInt(res.data.valor)); //Se carga nuevamente el combo con los datos correspondientes
        }).catch((error) => {
          console.log(error);
          setLoader({ loading: false, message: "" });
        });

        getEntities(detalle[i].idProcesoElectoral, detalle[i].idDetalleProceso).then((res) => {
          setEntities(res.data);

          // PEL2025: Se establace el valor de las entidades de seguimiento.
          //setEntSeguimiento(res.data)

        }).catch((e) => {
          console.log("Error al obtener las entidades");
        });
        break;
      }
    }
  };

  /**
   *
   * @param {*} idEstado
   * @param {*} idDistrito
   * Función que retorna el json que concida con el idEstado y el idDistrito
   */
  const getAdressFun = (idEstado, idDistrito) =>
    //Busca en el arreglo de juntas
    juntas.juntas.find(
      (junta) =>
        junta.idDistritoFederal === idDistrito && junta.idEstado === idEstado
    );

  /**
   *
   * @param {*} idPuesto
   * @param {*} array
   * Función que recibe un JsonArray para buscar el funcionario de acuerdo al idPiuesto enviado
   */
  const getByFuncionario = (idPuesto, array) => {
    if (array) {
      return array.find((array) => array.idPuesto === idPuesto);
    }
    return undefined;
  };

  const onChangeVotoExtranjero = (e) => {

    datos.votoExtranjero = e.target.value;

    if(e.target.value === 1) {

      setLoader({ loading: true, message: MSN_GUARDAR });

      getPaisesVotoExtranjero().then((res) => {

        setPaisesVotoExtranjero(res.data.paisesVotoExtranjero);
        setLoader({ loading: false, message: "" });

      }).catch((error) => {
        console.log(error);
        setPaisesVotoExtranjero([]);
        setLoader({ loading: false, message: "" });
      });

    } else {
      setPaisesVotoExtranjero([]);
      setSedesVotoExtranjero([]);
    }
  };

  const onSelectPaisVotoExtranjero = (e) => {

    let idPais = e;
    datos.paisVotoExtranjero = idPais;
    setLoader({ loading: true, message: MSN_GUARDAR });

    form.setFieldsValue({ //Se asigna undefined al combo por si previamente tenía una selección de sede
      sedeVotoExtranjero: undefined
    });

    getSedesVotoExtranjero(idPais).then((res) => {
      setSedesVotoExtranjero(res.data.sedesVotoExtranjero);
      setLoader({ loading: false, message: "" });
    }).catch((error) => {
      console.log(error);
      setSedesVotoExtranjero([]);
      setLoader({ loading: false, message: "" });
    });
  };

  //Verifica si la opción seleccionada es OTRO para mostrar el campo de texto
  const onSelectTipoDiscapacidad = (value) => {
    if (value === selectDiscapacidades.length ) {
      setShowOtraDiscapacidad(true); 
    } else {
      setShowOtraDiscapacidad(false);
    }
  };

  return (

    <Form form={form} layout="vertical" style={{ marginTop: 30 }}>

      <h3>Datos adicionales</h3>

      <Row gutter={24}>
        <Col span={24}>
          <p>Modalidad para la capacitación</p>
        </Col>
        <Col span={24}>

          <Form.Item  label=" ¿Cómo deseas tomar el curso de capacitación?"
                      name="capacitacion"
                      initialValue={ datos.capacitacion}
                      rules= {radioButton} >

              <Radio.Group onChange={handleChange("capacitacion")} 
                           disabled={disabledObs}>

                <Radio value={1} style={{marginRight: "50px"}} disabled={true}>
                  Virtual 
                  <div className="textRadio">
                    (a través del portal público de Observadoras/es).
                  </div>
                </Radio>

                <Radio value={2}>
                  Presencial o a Distancia a través de alguna herramienta o Plataforma
                  <div className="textRadio">
                    (Zoom, Google Meet, Microsoft Teams o algún otro).
                  </div>
                </Radio>

              </Radio.Group>

          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>

        <Col span={24}>
          {/*<h3 hidden={ ambitoProceso === "F" }>Entidad a observar</h3>*/}
          {/* 
            PEL2025: Se solicito que el usuario pueda seleccionar las entidades que desea observar. 
            Por lo cual que se comento la linea de arriba
          */}
          <h3 hidden={ ambitoProceso === "F" }>Entidad de seguimiento</h3>
          <h3 hidden={ ambitoProceso === "L" || ambitoProceso === "sin proceso"}>Entidad de seguimiento</h3>
        </Col>
        <Col span={8} xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>

          <Form.Item label="Entidad"
                     name="entidadJunta"
                     //initialValue: datos.idEntidad && parseInt(datos.idEntidad),
                     rules={ required } >

              <Select placeholder="Selecciona"
                      disabled={modificar || consultar}
                      onSelect={(value, e) => getStateAdditional(value, e)}
                      showSearch
                      filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                      }
                        /* disabled={disabledObs || modificar} */
                        //onChange={getStateAdditional}                        
                      >

                  {juntas.estados.map((item, i) => (
                    <Option key={i} value={item.id.idEstado}>
                      {item.nombreEstado}
                    </Option>
                  ))}
              </Select>
          </Form.Item>
        </Col>
        <Col span={8} xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>

          <Form.Item label="Junta que dará seguimiento a tu solicitud"
                     name="juntaEjecutiva"
                     initialValue={ datos.juntaEjecutiva }
                     rules= { required } >

              <Select placeholder="Selecciona"
                      onChange={changeSelect("juntaEjecutiva")}
                      /* disabled={disabledObs || modificar} */
                      disabled={modificar || consultar} >

                {juntas.juntas.map((item, i) => (
                  <Option
                    value={
                      item.idDistritoFederal +
                      "|" +
                      item.nombreSede +
                      "|" +
                      item.direccion
                    }
                    key={i}
                  >
                    {item.nombreSede} {item.idDistritoFederal} -{" "}
                    {item.direccion}
                  </Option>
                ))}
              </Select>
          </Form.Item>
        </Col>

        <Col span={8} xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>

          {form.getFieldValue("juntaEjecutiva") && (!disabledObs || ratifica || !modificar) && (
            <Form.Item label="Dirección de la junta ejecutiva ">
              {adress(form.getFieldValue("juntaEjecutiva"))}
            </Form.Item>
          )}

        </Col>
      </Row>

      {/* 
        PEL2025: Se solicito que el usuario pueda seleccionar las entidades que desea observar. 
        Por lo cual se agrega a la condición para proceseo federal o local
      */}
      { ambitoProceso === 'F' || ambitoProceso === 'L' ?
      <>
        <h3 style={{ marginTop: 30 }}>Entidad a observar</h3>
        <Row gutter={24}>
          <Form.Item label="¿En qué entidad o entidades deseas observar la Jornada Electoral?"
                     name="entObservar"
                     initialValue={ datos.entObservar }
                     rules= {radioButton} >

              <Radio.Group onChange={handleChange("entObservar")} disabled={disabledObs}>

                <Radio value={0} 
                       style={{ marginRight: 50 }} 
                       disabled={disabledRadio} >

                  Sólo en la entidad de mi credencial
                  <div className="textRadio">
                    (Tu credencial corresponde a {datos.entidad}).
                  </div>
                </Radio>

                <Radio value={1}>
                  En una o más entidades distintas
                  <div className="textRadio">
                    <p></p>
                  </div>
                </Radio>
              </Radio.Group>

          </Form.Item>

          <Col span={24}>
            {/* datos.entObservar === 1 && */}

            { showComboEstados && (
              <Form.Item label="Entidades" 
                         name="entidades"
                         rules={ radioButton } >

                  <Select disabled={disabledObs}
                          optionFilterProp="children"
                          onSelect={changeSelect("entidades")}
                          mode="multiple"
                          style={{ width: '50%' }}
                          filterOption={(input, option) =>
                            option.props.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                          placeholder="Selecciona uno o más estados" >

                    {entities.map((item) => (
                        <Option key={item.value}>{item.label}</Option>
                    ))}  
                  </Select>
              </Form.Item>
              
            )}
          </Col>
        </Row>
        </>
      :
      <>
        <Row>
          <Col span={24} style={{ marginBottom: "30px" }}>
            <Alert message={<p style={{ marginBottom: "0px" }}>
              En caso de querer observar más de una entidad es necesario registrar una nueva cuenta con un correo electrónico distinto.</p>}
              type="info" showIcon 
            />
          </Col>
        </Row>
      </>
      }
      <Row>
        <Col span={24}>

          <h4><Ast /> ¿Te interesa observar el voto de las personas en prisión preventiva?</h4>

          <Form.Item name="prisionPrev"
                     rules={ required }>

              <Radio.Group disabled={true}
                           onChange={handleChange("prisionPrev")} >

                <Radio value={1}>Si</Radio>
                <Radio value={0}>No</Radio>

              </Radio.Group>

          </Form.Item>

        </Col>
      </Row>
      <Row>
          <Col span={24}>

            <h4><Ast /> ¿Te interesa observar el proceso de voto anticipado?</h4>

            <Form.Item name="votoAnticipado" 
                       rules= {required } >

                <Radio.Group  disabled={disabledObs} 
                              onChange={handleChange("votoAnticipado")}>

                  <Radio value={1}>Si</Radio>
                  <Radio value={0}>No</Radio>

                </Radio.Group>

            </Form.Item>

          </Col>
      </Row>
      <Row>
        <Col span={24}>

          <h4><Ast /> ¿Va a realizar la observación de la elección de manera presencial en el extranjero?</h4>

          <Form.Item name="votoExtranjero" 
                     rules={ required } >

              {/* PEL2024-2025. Se quita esta opción disabled={disabled.input} 
                  que funciona de manera dinamica del <Radio.Group porque para este proceso no hay voto en el extranjero.
                  Por lo que el usuario pidio que se deshabilite
                */}
              <Radio.Group disabled={true}
                           onChange={onChangeVotoExtranjero} 
                           rules= {required } >

                <Radio value={1} >Si</Radio>
                <Radio value={0} >No</Radio>

              </Radio.Group>

          </Form.Item>

        </Col>
      </Row>

      {datos.votoExtranjero === 1 && (
        <Row>
          <Col span={8}>

            <Ast /> País donde realizará la observación 
            <Form.Item name="paisVotoExtranjero" 
                       rules={ required } >

              <Select placeholder="Selecciona" 
                      disabled={disabledObs} 
                      onSelect={onSelectPaisVotoExtranjero} >

                {paisesVotoExtranjero.map((item, i) => (
                  <Option key={i} value={item.idPais}>{item.nombrePais}</Option>
                ))}

              </Select>

            </Form.Item>

          </Col>
          <Col span={1} />
          <Col span={8}>

            <Ast /> Sede 
            <Form.Item name="sedeVotoExtranjero" 
                       rules={ required } >

                <Select placeholder="Selecciona" 
                        disabled={disabledObs} 
                        onSelect={changeSelect("sedeVotoExtranjero")}>

                  {sedesVotoExtranjero.map((item, i) => (
                    <Option key={i} value={item.idSede}>{item.nombreSede.toUpperCase()}</Option>
                  ))}

                </Select>
            </Form.Item>
          </Col>
        </Row>
      )}
      <Row>
        <h3>Datos para fines estadísticos</h3>
        <Col span={24}>

          {!disabledObs && <Ast />} ¿Pertenece a una comunidad indígena? 
          <Form.Item name="comunidadIndigena" 
                      rules= {required } >

            <Radio.Group disabled={disabledObs} 
                         onChange={handleChange("comunidadIndigena")} >

              <Radio value={1}>Si</Radio>
              <Radio value={0}>No</Radio>
              <Radio value={2}>Prefiero no responder</Radio>

            </Radio.Group>

          </Form.Item>

        </Col>
          <Col span={24}>

            {!disabledObs && <Ast />} ¿Cuenta con alguna discapacidad? 

            <Form.Item 
              name="discapacidad" 
              rules={ required } >

              <Radio.Group disabled={disabledObs}  
                           onChange={handleChange("discapacidad")} >

                <Radio value={1}>Si</Radio>
                <Radio value={0}>No</Radio>
                <Radio value={2}>Prefiero no responder</Radio>

              </Radio.Group>

            </Form.Item>

            <Row>
            {(datos.discapacidad === 1) && ( 
                <Col span={8}>
                  <Form.Item 
                    name="tipoDiscapacidad" 
                    label="Discapacidad"
                    rules={required}
                  >
                    <Select 
                      placeholder="Selecciona"
                      disabled={disabledObs}
                      onSelect={onSelectTipoDiscapacidad}
                    >
                      {selectDiscapacidades.map((item, i) => (
                          <Option key={i} value={item.idTipoDiscapacidad}>{item.nombreDiscapacidad}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>    
              )}
              { datos.discapacidad === 1 && showOtraDiscapacidad && (          
                <Col span={16} style={{paddingLeft: '10px'}}>
                  <Form.Item  name="txtDiscapacidad" 
                              label = "¿Cuál?"
                              rules={ calle } >
                      <Input onChange={handleChange("txtDiscapacidad")} 
                             disabled={disabledObs} 
                             maxLength={200} />
                  </Form.Item>
                </Col>
              )}                    
              </Row>
            </Col>
        </Row>

        {/* ¿COMO TE ENTERASTE(O) DE LA CONVOCATORIA? */}
        <Row>
          <Col span={12} style={{ paddingRight: "20px" }}>

            <Form.Item label="¿Cómo te enteraste de la convocatoria? "
                       name="convocatoriaOrigenCatalogo" >

                <Select placeholder="Selecciona" 
                        disabled={disabledObs} 
                        onSelect={(value, e) => onChangeConvOrigen(value, e)} >

                  {selectCatConvOrigen.map((item) => (
                    <Option key={item.idConvOrigen}>{item.descripcion}</Option>
                  ))}
                </Select>

            </Form.Item>

          </Col>
          <Col span={12} >
            {showTxtConvOrigen ? 
                <Row>
                  <Col span={24}>

                    <Form.Item label="¿Cuál?" 
                               name="convocatoriaOrigen" 
                               rules= { required ? calle : "" } >

                      <Input maxLength={200} disabled={disabledObs} />
                    </Form.Item>
                  </Col>                    
                </Row>
                : null
            }
          </Col>
        </Row>        
    </Form>
  );
}
